import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { RelatorioService } from '../../relatorio/comprovantes/relatorio-comprovante.service';
import { ServicosUtilidadesService } from '../../servicos-utilidades/servicos-utilidades.service';
import { MarcacaoComponent } from '../marcacao.component';

@Component({
  selector: 'app-marcacao-consulta-realizada',
  templateUrl: './marcacao-consulta-realizada.component.html',
  styleUrls: ['./marcacao-consulta-realizada.component.css']
})
export class MarcacaoConsultaRealizadaComponent extends MarcacaoComponent implements OnInit {

  valorDaConsultaFormatado: string = '';

  constructor(router: Router, private relatorioService: RelatorioService,
    private dialog: MatDialog, private servicosUtilidadesService: ServicosUtilidadesService) {

    super(router);
  }

  ngOnInit(): void {

    this.configurarTitulo('(Concluído)', TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA);

    if (!this.marcacaoConsulta || !this.marcacaoConsulta.pk ||
      this.marcacaoConsulta.pk.idFilial == 0 || this.marcacaoConsulta.pk.idPaciente == 0 ||
      this.marcacaoConsulta.pk.idPlanoSaude == 0 || !this.marcacaoConsulta.pk.dataMarcacaoConsulta ||
      this.marcacaoConsulta.pk.idProcedimentoConsulta == 0) {

      this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
        state: {
          tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
        }
      });
    } else {
      if (!this.marcacaoConsulta.comprovanteSMSEnviadoAutomaticamente) {
        /*
        if (environment.appAlias == 'COPE_AGENDA') {
          this.enviarComprovanteConsultaPorSMS();
        }
        */
      }
    }
  }

  onSubmit() {
    this.proximaTela();
  }

  proximaTela(): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
      }
    });
  }

  telaAnterior(): void {
    this.router.navigate(['/paginaInicial']);
  }

  enviarComprovantePorEmail(): void {
    this.router.navigate(['/marcacaoConsulta/enviarComprovantePorEmail'], {
      state: {
        marcacaoConsulta: this.marcacaoConsulta,
        tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
      }
    });
  }

  enviarComprovantePorSMS(): void {
    this.router.navigate(['/marcacaoConsulta/enviarComprovantePorSMS'], {
      state: {
        marcacaoConsulta: this.marcacaoConsulta,
        tipoMarcacao: 'TIPO_MARCACAO_CONSULTA'
      }
    });
  }

  imprimirComprovante(): void {
    if (this.marcacaoConsulta && this.marcacaoConsulta.pk && this.marcacaoConsulta.pk.idFilial &&
      this.marcacaoConsulta.pk.idPaciente && this.marcacaoConsulta.pk.idPlanoSaude &&
      this.marcacaoConsulta.pk.dataMarcacaoConsulta && this.marcacaoConsulta.pk.idProcedimentoConsulta) {

      this.relatorioService.gerarComprovanteMarcacaoConsulta(this.marcacaoConsulta.pk)
        .subscribe((response: BlobPart) => {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          this.dialog.open(InfoDialogComponent, {
            data: {
              title: 'Info',
              message: 'Impressão realizada com sucesso!'
            }
          });
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não foi possível imprimir o comprovante. Marcação não encontrada!'
        }
      });
    }
  }

  enviarComprovanteConsultaPorSMS(): void {

    if (this.marcacaoConsulta && this.marcacaoConsulta.pk &&
      this.marcacaoConsulta.pk.idPaciente && this.marcacaoConsulta.paciente &&
      this.marcacaoConsulta.paciente.foneCelular) {

      this.marcacaoConsulta.comprovanteSMSEnviadoAutomaticamente = true;

      this.servicosUtilidadesService.enviarSMSAgendamentoConsulta(this.marcacaoConsulta,
        this.marcacaoConsulta.paciente.foneCelular)
        .subscribe(data => {

          console.log(data);

        }, error => {

          console.log(error);

        });
    }
  }
}
